import { HomeInvitationTable } from './HomeInvitationTable';
export default HomeInvitationTable;
